/* eslint-disable @wyz/module/no-relative-import */
import { Icon } from '@wyz/ui';
import { Trans } from '~/common/context';
import { Link, useMatch } from 'react-router';
import './quote-mode-switcher.scss';

function QuoteModeSwitcher() {
  const isServiceMode = Boolean(useMatch('/quotes/services/*'));

  return (
    <div className='quote-mode-switcher mt-4'>
      <Link
        to='/quotes/search'
        className={`quote-mode-tab${!isServiceMode ? ' quote-mode-tab--active' : ''}`}
      >
        <div className='quote-mode-tab__icon'>
          <Icon icon='tyre' size='sm' />
        </div>
        <div className='quote-mode-tab__content'>
          <div className='quote-mode-tab__title'>
            <Trans i18nKey='app.purchase.quote_search.mode.tyres.title' />
          </div>
          <div className='quote-mode-tab__subtitle'>
            <Trans i18nKey='app.purchase.quote_search.mode.tyres.subtitle' />
          </div>
        </div>
        <div className='quote-mode-tab__chevron'>
          <Icon
            icon={!isServiceMode ? 'arrow-down' : 'arrow-right'}
            size='xs'
          />
        </div>
      </Link>
      <Link
        to='/quotes/services/search'
        className={`quote-mode-tab${isServiceMode ? ' quote-mode-tab--active' : ''}`}
      >
        <div className='quote-mode-tab__icon'>
          <Icon icon='quote-service' size='sm' />
        </div>
        <div className='quote-mode-tab__content'>
          <div className='quote-mode-tab__title'>
            <Trans i18nKey='app.purchase.quote_search.mode.services.title' />
          </div>
          <div className='quote-mode-tab__subtitle'>
            <Trans i18nKey='app.purchase.quote_search.mode.services.subtitle' />
          </div>
        </div>
        <div className='quote-mode-tab__chevron'>
          <Icon icon={isServiceMode ? 'arrow-down' : 'arrow-right'} size='xs' />
        </div>
      </Link>
    </div>
  );
}

export default QuoteModeSwitcher;
